import { api } from '@/services/api/main/axios';

type ColumnsGroupSetting = {
  name?: string;
  isOpened?: boolean;
  columns: string[];
  groupId: string;
};

export const getColumnsGroupsSettingApiRequest = async (): Promise<ColumnsGroupSetting[]> => {
  const res = await api.get<{ payload: ColumnsGroupSetting[] }>('columns-groups-setting');
  return res.data.payload;
};

export const postColumnsGroupsSettingApiRequest = async (
  payload: ColumnsGroupSetting[],
): Promise<ColumnsGroupSetting[]> => {
  const res = await api.post<{ payload: ColumnsGroupSetting[] }>('columns-groups-setting', payload);
  return res.data.payload;
};
